import React from 'react'
import { Link } from 'react-router-dom'

function LetsWorkTogether() {
  return (
    <>
      <section className="app-cta pad-tb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="common-heading text-w">
                <span>Let's work together</span>
                <h2>We Love to Listen to Your Requirements</h2>
                <Link to="/contactus" className="btn-main bg-btn4 lnk">
                  GET STARTED<i className="fas fa-chevron-right fa-icon"></i>
                  <span className="circle"></span>
                </Link>
                <p className="cta-call">
                  Email us now{" "}
                  <a href="mailto:info@ndtechland.com">
                    info@ndtechland.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="shape shape-c1"></div>
        <div className="shape shape-c2"></div>
        <div className="shape shape-c3"></div>
      </section>

    </>
  )
}

export default LetsWorkTogether